import React, { useEffect } from "react";
import { PlayerItem } from "../playerItem/PlayerItem";
import "./PlayersList.css";
import { Player } from "../../apis/types";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { observer } from "mobx-react-lite";
import { GuestPlayerCounter } from "../guestPlayerCounter/GuestPlayerCounter";

interface PlayersListProps {
  players: Player[];
  isExcludePlayers?: boolean;
}

export const PlayersList: React.FC<PlayersListProps> = observer(
  ({ players, isExcludePlayers }) => {
    const selectCircleStore = useSelectCircleStore();
    const listRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (listRef.current) {
        const { scrollHeight, clientHeight } = listRef.current;
        if (
          scrollHeight <= clientHeight &&
          !selectCircleStore.isLoading &&
          players.length > 0
        ) {
          selectCircleStore.increasePageNum();
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [players, selectCircleStore.isLoading]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
      if (
        scrollHeight - scrollTop - clientHeight < 50 &&
        !selectCircleStore.isLoading
      ) {
        selectCircleStore.increasePageNum();
      }
    };

    const isPlayerSelected = (player: Player) => {
      if (isExcludePlayers) {
        return selectCircleStore.isPlayerExcluded(player.userId);
      } else {
        return selectCircleStore.isPlayerSelected(player.userId);
      }
    };

    const handlePlayerSelect = (player: Player) => {
      if (isExcludePlayers) {
        selectCircleStore.togglePlayerExclusion(player);
      } else {
        selectCircleStore.togglePlayerSelection(player);
      }
    };

    return (
      <div className="players-list" ref={listRef} onScroll={handleScroll}>
        {selectCircleStore.isLoading && !players.length ? (
          <div style={{ height: "100vh" }} />
        ) : (
          <>
            {!isExcludePlayers && <GuestPlayerCounter />}
            {players.map((player) => (
              <PlayerItem
                key={player.userId}
                name={player.name}
                lastMatch={player.lastMatchDate}
                imageUrl={player.userImageUrl}
                rating={player.userRating.toString()}
                isSelected={isPlayerSelected(player)}
                onSelect={() => handlePlayerSelect(player)}
                isExclude={isExcludePlayers}
              />
            ))}
          </>
        )}
      </div>
    );
  }
);
